module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp12_7005.50cd748a.png";